var DualRangeInput = class {
    constructor($min, $max, precision = 3) {
        this.updateFloor = () => this.update("floor");
        this.updateCeil = () => this.update("ceil");
        this.$min = $min;
        this.$max = $max;
        this.precision = precision;
        this.$min.addEventListener("input", this.updateCeil);
        this.$max.addEventListener("input", this.updateFloor);
        this.$min.addEventListener("focus", this.updateCeil);
        this.$max.addEventListener("focus", this.updateFloor);
        this.$min.addEventListener("mousedown", this.updateCeil);
        this.$max.addEventListener("mousedown", this.updateFloor);
        this.$min.addEventListener("touchstart", this.updateCeil);
        this.$max.addEventListener("touchstart", this.updateFloor);
        this.update();
        this.$min.dataset.ready = "true";
        this.$max.dataset.ready = "true";
    }
    update(method = "ceil") {
        const thumbWidthVar = "var(--dri-thumb-width)";
        const min = parseFloat(this.$min.min);
        const max = parseFloat(this.$max.max);
        const step = parseFloat(this.$min.step) || 1;
        const minValue = parseFloat(this.$min.value);
        const maxValue = parseFloat(this.$max.value);
        const midValue = (maxValue - minValue) / 2;
        const mid = minValue + Math[method](midValue / step) * step;
        const range = max - min;
        const leftWidth = ((mid - min) / range * 100).toFixed(this.precision);
        const rightWidth = ((max - mid) / range * 100).toFixed(this.precision);
        this.$min.style.flexBasis = `calc(${leftWidth}% + ${thumbWidthVar})`;
        this.$max.style.flexBasis = `calc(${rightWidth}% + ${thumbWidthVar})`;
        this.$min.max = mid.toFixed(this.precision);
        this.$max.min = mid.toFixed(this.precision);
        const minFill = (minValue - min) / (mid - min) || 0;
        const maxFill = (maxValue - mid) / (max - mid) || 0;
        const minFillPercentage = (minFill * 100).toFixed(this.precision);
        const maxFillPercentage = (maxFill * 100).toFixed(this.precision);
        const minFillThumb = (.5 - minFill).toFixed(this.precision);
        const maxFillThumb = (.5 - maxFill).toFixed(this.precision);
        this.$min.style.setProperty("--dri-gradient-position", `calc(${minFillPercentage}% + (${minFillThumb} * ${thumbWidthVar}))`);
        this.$max.style.setProperty("--dri-gradient-position", `calc(${maxFillPercentage}% + (${maxFillThumb} * ${thumbWidthVar}))`);
    }
    destroy() {
        this.$min.removeEventListener("input", this.updateFloor);
        this.$max.removeEventListener("input", this.updateCeil);
        this.$min.removeEventListener("focus", this.updateFloor);
        this.$max.removeEventListener("focus", this.updateCeil);
        this.$min.removeEventListener("mousedown", this.updateCeil);
        this.$max.removeEventListener("mousedown", this.updateFloor);
        this.$min.removeEventListener("touchstart", this.updateCeil);
        this.$max.removeEventListener("touchstart", this.updateFloor);
    }
};

var range_slider_default = (() => {
    if (!customElements.get("range-slider")) customElements.define("range-slider", class RangeSlider extends HTMLElement {
        constructor() {
            super();
            this.rangeMin = this.querySelector("[data-range-min]");
            this.rangeMax = this.querySelector("[data-range-max]");
            this.inputMin = this.querySelector("[data-input-min]");
            this.inputMax = this.querySelector("[data-input-max]");
        }
        connectedCallback() {
            this.dualRange = new DualRangeInput(this.rangeMin, this.rangeMax);
            this.addEventListeners();
        }
        disconnectedCallback() {
            if (this.dualRange) this.dualRange.destroy();
        }
        addEventListeners() {
            this.inputMin.addEventListener("focus", () => this.inputMin.select());
            this.inputMax.addEventListener("focus", () => this.inputMax.select());
            this.inputMin.addEventListener("change", event => {
                event.preventDefault();
                event.target.value = Math.max(Math.min(parseInt(event.target.value), parseInt(this.inputMax.value || event.target.max) - 1), event.target.min);
                this.rangeMin.value = event.target.value;
                this.style.setProperty("--min", `${parseInt(this.rangeMin.value) / parseInt(this.rangeMin.max) * 100}%`);
            });
            this.inputMax.addEventListener("change", event => {
                event.preventDefault();
                event.target.value = Math.min(Math.max(parseInt(event.target.value), parseInt(this.inputMin.value || event.target.min) + 1), event.target.max);
                this.rangeMax.value = event.target.value;
                this.style.setProperty("--max", `${100 - parseInt(this.rangeMax.value) / parseInt(this.rangeMax.max) * 100}%`);
            });
            this.rangeMin.addEventListener("change", event => {
                event.stopPropagation();
                this.inputMin.value = event.target.value;
                this.inputMin.dispatchEvent(new Event("change", {
                    bubbles: true
                }));
            });
            this.rangeMax.addEventListener("change", event => {
                event.stopPropagation();
                this.inputMax.value = event.target.value;
                this.inputMax.dispatchEvent(new Event("change", {
                    bubbles: true
                }));
            });
            this.rangeMin.addEventListener("input", event => {
                event.target.value = Math.min(parseInt(event.target.value), parseInt(this.inputMax.value || event.target.max) - 1);
                this.style.setProperty("--min", `${parseInt(event.target.value) / parseInt(event.target.max) * 100}%`);
                this.inputMin.value = event.target.value;
            });
            this.rangeMax.addEventListener("input", event => {
                event.target.value = Math.max(parseInt(event.target.value), parseInt(this.inputMin.value || event.target.min) + 1);
                this.style.setProperty("--max", `${100 - parseInt(event.target.value) / parseInt(event.target.max) * 100}%`);
                this.inputMax.value = event.target.value;
            });
        }
    });
})();